/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import { LanguageProvider } from "./src/context/LanguageContext"
import "./src/styles/global.css"

export const wrapPageElement = ({ element, props }) => (
  <LanguageProvider pageContext={props.pageContext}>{element}</LanguageProvider>
)
